var map = {
	"./0.jpg": 567,
	"./1073.jpg": 774,
	"./1163.jpg": 775,
	"./1216.jpg": 776,
	"./1267.jpg": 777,
	"./216.jpg": 778,
	"./2839.jpg": 779,
	"./2840.jpg": 780,
	"./2971.jpg": 781,
	"./4279.jpg": 782,
	"./4309.jpg": 783,
	"./4379.jpg": 784,
	"./4386.jpg": 785,
	"./4399.jpg": 786,
	"./44.jpg": 787,
	"./45.jpg": 788,
	"./4590.jpg": 789,
	"./4594.jpg": 790,
	"./46.jpg": 791,
	"./4633.jpg": 792,
	"./4678.jpg": 793,
	"./49.jpg": 794,
	"./5835.jpg": 795,
	"./6106.jpg": 796,
	"./6139.jpg": 797,
	"./6194.jpg": 798,
	"./6195.jpg": 799,
	"./66.jpg": 568,
	"./76.jpg": 800,
	"./80.jpg": 801,
	"./81.jpg": 569,
	"./avetar.jpg": 87
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;